import { createListenerMiddleware } from '@reduxjs/toolkit';

import { PlayerConfigFetcher } from '../../api/fetchers/playerConfig/fetcher';
import { fetchPlayerConfigAction } from '../apiActions/fetchPlayerConfigAction';
import { CorePredicator } from '../CorePredicator';
import type { CoreRootState } from '../CoreStore';
import { gameStateActions } from '../slices/game/slice';

export const playerConfigMiddleware = createListenerMiddleware<CoreRootState>();

playerConfigMiddleware.startListening({
  actionCreator: fetchPlayerConfigAction.fulfilled,
  effect: (_action, { dispatch, getState }) => {
    const state = getState();
    const tableId = state.config.session?.tableId;
    const netWinBalanceMap = state.config.playerConfig?.netWinBalanceMap || {};

    if (tableId && netWinBalanceMap[tableId]) {
      dispatch(gameStateActions.setNetPosition(Number(netWinBalanceMap[tableId])));
    }
  },
});

const unsubscribePlayerConfigOptionsListener = playerConfigMiddleware.startListening(
  CorePredicator.createListener(
    (state) => [state.config.tableConfig] as const,
    ([tableConfig]) => {
      PlayerConfigFetcher.setOperatorGameId(tableConfig.operatorGameId ?? '');
      PlayerConfigFetcher.setDedicatedLanguage(tableConfig.dedicatedLanguage ?? null);
      unsubscribePlayerConfigOptionsListener();
    }
  )
);
